import { getDeviceAppStore } from './appStores';
import { getAppDownloadUrl, resolveAppDownloadDeviceType } from './getAppDownloadUrl';
import { APP_STORE_ANALYTICS_NAMES } from '../config/appStores';
import type { AppDownloadOptions, AppStore } from '../model/types';

interface AnalyticsWindow {
  dataLayer?: Record<string, unknown>[];
}

function pushAppDownloadEvent(store: AppStore): void {
  const analyticsWindow = window as Window & AnalyticsWindow;

  analyticsWindow.dataLayer ??= [];
  analyticsWindow.dataLayer.push({
    event: 'selectContent',
    selectContent: {
      prop: [
        {
          type: 'gooutBanner',
          value: `DownloadApp_Установите приложение. Скачать ${APP_STORE_ANALYTICS_NAMES[store]}`,
        },
      ],
    },
  });
}

export function downloadApp(options: AppDownloadOptions): void {
  if (typeof window === 'undefined') {
    return;
  }

  const deviceType = resolveAppDownloadDeviceType(options.deviceType);

  if (options.trackDataLayer !== false) pushAppDownloadEvent(getDeviceAppStore(deviceType));
  window.open(getAppDownloadUrl({ ...options, deviceType }), '_blank', 'noopener');
}
